import React, { Component } from "react";
import { Link } from "react-router-dom";
import { injectIntl } from "react-intl";
import { getClassName } from "ui-kit/utils/component";

import "./MobileNav.scss";

import settings from "../img/settings.png";
import help from "../img/help.png";
import disclosures from "../img/disclosures.png";
import logout from "../img/logout.png";

const ccn = getClassName("MobileNav");
const subNavItems = [
  {
    id: 5,
    value: "Settings",
    link: "/settings",
    icon: settings,
    hidden: false
  },
  {
    id: 6,
    value: "Help",
    link: "//support.hedgedbitcoin.com/hc/en-us/",
    icon: help,
    hidden: false
  },
  {
    id: 7,
    value: "Disclosures",
    link: "/disclosures",
    icon: disclosures,
    hidden: false
  },
  {
    id: 8,
    value: "Logout",
    link: "/logout",
    icon: logout,
    hidden: false,
    logout: true
  }
];

class MobileNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      hiddenSub: true,
      countNewNotification: 0
    };
  }

  componentWillReceiveProps(next) {
    if(next.userData && next.userData.countNewNotification>=0) {
      this.setState({countNewNotification: next.userData.countNewNotification})
    }
  }

  handleClick = () => {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  };

  openSubs = () => {
    this.setState(prevState => ({
      hiddenSub: !prevState.hiddenSub
    }));
  }

  logOut = () => {
    const { logOut } = this.props;
    logOut()
  }

  render() {
    const { items, userData, isAuthorized, mobileLang, intl: { formatMessage }  } = this.props;
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return (
      <nav className={`${ccn()} ${this.state.open ? `${ccn()}--open` : ""}`}>
        <div className={ccn("burger")} onClick={this.handleClick}>
          <span />
          <span />
          <span />
        </div>
        <div className={ccn(`block${(/iPhone/.test(userAgent) && !window.MSStream)?" iphone-device":""}`)}>
          <ul>
            <li><p><span onClick={this.handleClick}></span>{userData && `${userData['name']}`}</p></li>
            {items.slice(0, -1).concat(subNavItems).map(item => (
              <li key={item.id} className={`${item.hidden && this.state.hiddenSub ? `${ccn()}--hidden` : `${ccn()}--open`}`} onClick={isAuthorized && item.submenu ? this.openSubs : isAuthorized && item.logout ? this.logOut : null}>
                <Link to={`${item.link&&item.link!=="#"&&item.id!==6?"/":""}${item.link&&item.link!=="#"&&item.id!==6?mobileLang.toLowerCase():""}${item.link}`} target={`${item.id!==6?"":"_blank"}`}>
                  <img src={item.icon} alt="icon" />
                    {formatMessage({ id: `hbc.header.menu${item.id}`, defaultMessage: `${item.value}`})}
                    {item.notification && (this.state.countNewNotification > 0) && <span>{this.state.countNewNotification}</span>}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    );
  }
}

export default injectIntl(MobileNav);



// WEBPACK FOOTER //
// ./src/components/header/mobile-nav/MobileNav.js